document.addEventListener("DOMContentLoaded", () => {
  const tooltipTriggers = document.querySelectorAll("[data-tooltip]");

  tooltipTriggers.forEach(trigger => {
    trigger.addEventListener("click", e => {
      const parent = e.target.closest(".prd-MediaImageDetails_Tooltip");
      document.querySelectorAll(".prd-MediaImageDetails_Tooltip.active").forEach(t => {
        if (t !== parent) t.classList.remove("active");
      });
      parent.classList.toggle("active");
    });
  });

  document.addEventListener("click", e => {
    if (!e.target.closest(".prd-MediaImageDetails_Tooltip")) {
      document.querySelectorAll(".prd-MediaImageDetails_Tooltip.active").forEach(t => 
        t.classList.remove("active")
      );
    }
  });
});

// document.addEventListener("DOMContentLoaded", () => {
//   // Find all media-image wrappers on page
//   const mediaWrappers = document.querySelectorAll(".media-img-wapper");

//   mediaWrappers.forEach(mediaWrapper => {
//     const img = mediaWrapper.querySelector("img");
//     const tooltipWrapper = mediaWrapper.nextElementSibling?.classList.contains("custom-tooltip-wapper")
//       ? mediaWrapper.nextElementSibling
//       : null;

//     if (img && tooltipWrapper) {
//       // Function to set tooltip width
//       const setTooltipWidth = () => {
//         const imgWidth = img.offsetWidth;
//         tooltipWrapper.style.width = `${imgWidth}px`;
//       };

//       // Set width initially and also on resize/load
//       setTooltipWidth();
//       window.addEventListener("resize", setTooltipWidth);
//       img.addEventListener("load", setTooltipWidth);
//     }
//   });
// });
